export default "__VITE_ASSET__d6035548__"